<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(/img/temp/blurred-dark.jpg"></div>
    
      <base-header class="header--recipe pb-6" type="none">
        <b-row align-v="center" class="py-4">
          <b-col xs="12">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
              <RouteBreadCrumb />
            </nav>
          </b-col>
        </b-row>
        <b-row align-v="center" class="py-4">
          <b-col xs="12" lg="6" align="left">
            <h2 class="text-white">{{ tag.name }}</h2>
            <img v-if="tag.image" :src="tag.image.absoluteUri" />
          </b-col>
          <b-col xs="12" lg="6" align="right">
            <router-link :to="editLink" v-if="isAdmin"><base-button :to="editLink" v-if="isAdmin" type="secondary" size="sm" class="btn-secondary--alt">Edit Tag</base-button></router-link>
          </b-col>
        </b-row>
      </base-header>
    
      <RecipeList :searchUri="'recipes/searchRecipes'" :binder="this.$store.state.recipes.all" :payload="{ tagId: this.$route.params.id }" />
    </div>

</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import RecipeList from '@/views/Recipe/RecipeList.vue';

export default {
  components: {
    RouteBreadCrumb,
    RecipeList
  },
   computed: {
    tag() {
      return this.$store.state.tags.current;
    },
    isAdmin() {
      return this.$store.getters.userIsAdmin
    },
  },
  created() {
    this.editLink = `/tag/edit-tag/${this.$route.params.id}`;
    const { dispatch } = this.$store;
    dispatch("tags/getById", this.$route.params.id);
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
